import DetailsHeader from './components/headerdetails.vue'
import ConsentTerm from '@/views/private/finance/expenses/miscellaneous/term/consentterm.vue'
import Add from '@/views/private/finance/expenses/miscellaneous/add/add.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import TermType from '@/shared/utils/termtype.js'
import ModalDebt from './components/modal/debt/modalDebt.vue'
import ModalCredit from './components/modal/credit/modalCredit.vue'
import ModalDisapproved from './components/modal/disapproved/modalDisapproved.vue'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'
import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import Tools from '@/components/tools/Tools.js'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  mixins: [ ActionsForm ],
  name: 'MiscellaneousExpenseDetails',
  data () {
    return {
      objSelected: null,
      data: null,
      form: null,
      showTerm: false,
      showAdd: false,
      showDetails: true,
      typeTerm: TermType,
      totalBalance: 0
    }
  },
  components: {
    Add,
    DetailsHeader,
    ConsentTerm,
    ModalDebt,
    ModalCredit,
    ModalDisapproved
  },
  methods: {
    onLoad () {
    },
    onEditExpense (obj) {
      this.objSelected = obj
      this.$refs.DetailsHeader.obj = obj
      this.onLoadAllExpenseItem(obj)
    },
    onAddExpense () {
      this.showAdd = true
      this.showDetails = false
      this.showTerm = false
    },
    onSelect (obj) {
      if (obj.despesaTipo.forma !== 1) {
        this.$refs.ModalDebt.editModal(JSON.parse(JSON.stringify(obj)))
      } else {
        toast.warning('Você não pode editar um crédito', 'EDITAR DESPESA')
      }
    },
    showModalDebt () {
      this.$refs.ModalDebt.showModal(this.objSelected)
    },
    showModalCredit () {
      this.$refs.ModalCredit.showModal(this.objSelected)
    },
    showModalDisapproved () {
      var selected = this.objList.filter(e => e.checked).map(e => e.id)
      if (selected && selected.length > 0) {
        this.$refs.ModalDisapproved.showModal(this.objSelected, selected)
      } else {
        toast.info('Você precisa selecionar algum item para reprovar', 'REPROVAR ITEM')
      }
    },
    onLoadAllExpenseItem (obj) {
      loading.push()
      ExpenseItemRepository.GetAll(obj.id)
        .then((response) => {
          if (response.data.code >= 0) {
            var data = response.data.data
            var balance = 0
            for (var i in data) {
              var total = data[i].valorTotal
              if (!data[i].incorrida) {
                if (data[i].forma) {
                  balance = balance + total
                  data[i].saldo = balance
                } else {
                  balance = balance - total
                  data[i].saldo = balance
                }
              } else {
                if (i > 0) {
                  data[i].saldo = data[i - 1].saldo
                } else {
                  data[i].saldo = 0
                }
              }
            }
            this.totalBalance = balance
            response.data.data = data
            this.onResultGrid(response)
          }
        })
        .catch(this.onException)
    },
    setReload () {
      if (this.objSelected) {
        this.onEditExpense(this.objSelected)
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onSectionApproval (obj) {
      if (obj) {
        loading.push()
        obj.situacao = 2
        ExpenseRepository.SetApproved(obj.id, obj.situacao)
          .then((response) => {
            this.onResult(response)
            this.objSelected = obj
            this.$refs.DetailsHeader.obj = obj
            loading.close()
          })
          .catch(this.onException)
      }
    },
    onApproval (obj) {
      if (obj) {
        loading.push()
        var situation = parseInt(obj.situacao) + 1
        obj.situacao = situation
        ExpenseRepository.SetApproved(obj.id, situation)
          .then((response) => {
            this.onResult(response)
            this.objSelected = obj
            this.$refs.DetailsHeader.obj = obj
            loading.close()
          })
          .catch(this.onException)
      }
    },
    onDisapproval (obj) {
      if (obj) {
        loading.push()
        var situation = parseInt(0 - obj.situacao)
        obj.situacao = situation
        ExpenseRepository.SetDisapproved(obj.id, situation)
          .then((response) => {
            this.onResult(response)
            this.objSelected = obj
            this.$refs.DetailsHeader.obj = obj
            loading.close()
          })
          .catch(this.onException)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/miscellaneous/details/details.js